import React, { useState } from 'react';
import { spaLogin as apiSpaLogin } from '../api/auth';
import { useAuth } from '../context/AuthContext'; // ← 追加！！
import { Link, useNavigate, useLocation } from 'react-router-dom'; // ← useNavigateも使う！
import ResendVerification from '../components/ResendVerification';
import styles from './LoginPage.module.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [resendVerificationToken, setResendVerificationToken] = useState('');
  const { login, refreshUser } = useAuth(); // ← useAuthからloginとrefreshUserを取得
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = (event) => {
    event.preventDefault();
    handleLogin();
  };

  const handleLogin = async () => {
    setError('');
    setResendVerificationToken('');

    try {
      const data = await apiSpaLogin({ email, password });

      login(data.user);
      try {
        if (refreshUser) await refreshUser();
      } catch (e) {
        // ignore
      }
      const params = new URLSearchParams(location.search);
      const rawNext = params.get('next') || params.get('redirect');
      let safeNext = '/profile/my';

      try {
        if (rawNext) {
          const url = new URL(rawNext, window.location.origin);
          if (url.origin === window.location.origin) safeNext = rawNext;
        }
      } catch {
        // 無効なURLはデフォルトにフォールバック
      }

      navigate(safeNext, { replace: true });
    } catch (err) {
      const responseData = err?.response?.data;

      if (responseData?.error_code === 'email_unverified') {
        setError(responseData?.message || 'メール認証が完了していません。認証メールをご確認ください。');
        setResendVerificationToken(responseData?.resend_verification_token || '');
        return;
      }

      if (err?.response?.status === 403 && responseData?.redirect_to === '/forgot-password') {
        const search = email ? `?email=${encodeURIComponent(email)}` : '';
        navigate(`/forgot-password${search}`, { replace: true });
        return;
      }

      setError(responseData?.message || 'ログインに失敗しました。');
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>ログイン</h2>

      {error && <p className={styles.error}>{error}</p>}
      <ResendVerification token={resendVerificationToken} />

      <form onSubmit={handleSubmit}>
        <input
          type="email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            if (resendVerificationToken) setResendVerificationToken('');
          }}
          placeholder="メールアドレス"
          autoComplete="email"
          style={{ display: 'block', marginBottom: '10px' }}
        />
        <input
          type="password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            if (resendVerificationToken) setResendVerificationToken('');
          }}
          placeholder="パスワード"
          autoComplete="current-password"
          style={{ display: 'block', marginBottom: '10px' }}
        />
        <button className={styles.loginButton} type="submit">ログイン</button>
      </form>

      <div className={styles.linkRow}>
        <Link to="/forgot-password" style={{ color: 'blue', textDecoration: 'underline' }}>
          パスワードを忘れた方はこちら
        </Link>
      </div>

      <div className={styles.linkRow}>
        <Link to="/register" style={{ color: 'blue', textDecoration: 'underline' }}>
          新規登録はこちら
        </Link>
      </div>
      <div className={styles.linkRow}>
        <Link to="/seller-register" style={{ color: 'blue', textDecoration: 'underline' }}>
          チケット販売をする方はこちらから登録をお願いします。
        </Link>
      </div>
    </div>
  );
};

export default LoginPage;
